import React, { ReactElement } from 'react';
import ProjectView, { ProjectFilters } from '../ProjectView/ProjectView';
import ProjectFilter from '../ProjectFilter/ProjectFilter';
import { useLocationQuery } from '../../hooks/locationHooks';
import PartnerCarousel from './PartnerCarousel/PartnerCarousel';
import NeubauprojekteInfo from './NeubauprojekteInfo/NeubauProjekteInfo';
import NeubauUpdates from './NeubauUpdates/NeubauUpdates';
import NeubaukarteInfo from './NeubaukarteInfo/NeubaukarteInfo';
import BeliebteSuchen from './BeliebteSuchen/BeliebteSuchen';
import '../Layout/Main.scss';
import usePageTracking from '../../hooks/usePageTracking';

const filterMap = {
  zip: 'zips',
  metro: 'subways',
  kaufen_mieten: 'buyOptions',
  planung_bau: 'projectStatus',
};

const getFilterFromSearch = (query): ProjectFilters => {
  const queries = Object.fromEntries(query.entries());
  const newFilters: ProjectFilters = {
    zip: undefined,
    metro: undefined,
    kaufen_mieten: undefined,
    planung_bau: undefined,
  };
  Object.keys(queries).forEach((queryKey) => {
    newFilters[filterMap[queryKey]] = queries[queryKey].split(',');
  });
  return newFilters;
};

const Home = (): ReactElement => {
  const query = useLocationQuery();
  const filter = getFilterFromSearch(query);
  usePageTracking(
    'Übersicht aktueller Neubauprojekte in Wien - Jetzt anfragen!'
  );
  return (
    <div>
      <ProjectFilter query={query} />
      <div className="mainContent">
        <ProjectView filter={filter} />
        <div className="separator" />
        <PartnerCarousel />
        <div className="separator" />
        <NeubauprojekteInfo />
        <div className="separator" />
        <NeubauUpdates />
        <div className="separator" />
        <NeubaukarteInfo />
        <div className="separator" />
        <BeliebteSuchen />
      </div>
    </div>
  );
};

export default Home;
